import { appRouterPaths } from 'services/navigation';
import { HomePage } from 'pages/Home';
import type { AppRouteProps } from '../types';

export const homePageRoute: AppRouteProps = {
  path: appRouterPaths.home,
  element: <HomePage />,
};
